import { Grid2 } from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";

import log from "loglevel";
import React, { useEffect, useState } from "react";
import { useStyle } from "./materialStyles";
import "./styles.scss";
import ResponsiveDatePicker from "components/common/form/ResponsiveDatePicker";


const DatePickerRange = ({
    onChange,
    start,
    end,
    dateName,
    fieldName,
    customLabel,
    noLabel,
    startSuffix = "Begin",
    endSuffix = "End",
    views = ["year", "month", "day"],
    labelStart = "Start",
    labelEnd = "End",
    gridItemProps = {
        xs: 12,
        md: 6,
    }
}) => {

    const classes = useStyle();

    const [startDate, setStartDate] = useState(start);
    const [endDate, setEndDate] = useState(end);

    useEffect(() => {
        setStartDate(start);
    }, [start]);

    useEffect(() => {
        setEndDate(end);
    }, [end]);


    function  validateStartDate(date) {
        if(endDate) {
            return endDate > date;
        }
        return true;
    }
    function  validateEndDate(date) {
        if(startDate) {
            return startDate < date;
        }
        return true;
    }

    function resetEndDate() {
        setEndDate(null);
    }
    function handleStartChange(date, context) {
        log.debug("handleStartChange", date, context);
        setStartDate(date);
        if(!context.validationError){
            if(!validateStartDate(date)) {
                resetEndDate();
            }
            onChange({
                [fieldName + startSuffix]: date,
                [fieldName + endSuffix]: null,
            });

        }
    }

    function handleEndDateChange(date, context) {
        log.debug("handleEndDateChange", date);
        setEndDate(date);
        if(!context.validationError){
            if(validateEndDate(date)) {
                onChange({
                    [fieldName + endSuffix]: date,
                });
            }
        }
    }

    function handleOnStartAccept(date, context) {
        log.debug("handleOnStartAccept", date);
        if(!context.validationError){
            if(!validateStartDate(date)) {
                resetEndDate();
            }
            onChange({
                [fieldName + startSuffix]: date,
                [fieldName + endSuffix]: null
            });
        }

    }
    function handleOnEndAccept(date, context) {
        log.debug("handleOnEndAccept", date);
        if(!context.validationError){
            if(validateEndDate(date, endSuffix)) {
                onChange({
                    [fieldName + endSuffix]: date,
                });
            }
        }

    }


    const endProps = {};
    if (startDate) {
        endProps.minDate = startDate;
    }
    return (
        <Grid2 className="datepicker-range" container columnSpacing={4} size={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                {!noLabel && <label className="datepicker-range-label">{dateName} Date</label>}
                {customLabel && <label className="datepicker-range-label">{customLabel}</label>}
                <Grid2 className="datepicker-wrapper start" size={gridItemProps}>
                    <ResponsiveDatePicker
                        className={classes.dateField}
                        inputVariant="outlined"
                        variant="dialog"
                        margin="normal"
                        label={noLabel ? labelStart : null}
                        value={startDate}
                        onChange={handleStartChange}
                        autoOk={false}
                        onAccept={handleOnStartAccept}
                        InputAdornmentProps={{
                            style: { marginLeft: 0 },
                        }}
                        slotProps={{
                            textField: {
                                className: classes.root,
                            }
                        }}
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                            className: classes.iconDatePicker,
                        }}
                        views={views}
                    />
                    {}
                </Grid2>
                <Grid2 className="datepicker-wrapper end" size={gridItemProps}>
                    <ResponsiveDatePicker
                        className={classes.dateField}
                        {...endProps}
                        inputVariant="outlined"
                        variant="dialog"
                        margin="normal"
                        label={noLabel ? labelEnd : null}
                        value={endDate}
                        onChange={handleEndDateChange}
                        autoOk={false}
                        onAccept={handleOnEndAccept}
                        InputAdornmentProps={{
                            style: { marginLeft: 0 },
                        }}
                        slotProps={{
                            textField: {
                                className: classes.root,
                            }
                        }}
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                            className: classes.iconDatePicker,
                        }}
                        views={views}
                    />
                    {}
                </Grid2>
            </LocalizationProvider>
        </Grid2>
    );
};


export default DatePickerRange;
